// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__9Av7j","submitButton":"styles_submitButton__PHDAR","input":"styles_input__WL1kE"};